export const KCQ_ID = 1;
export const MC_QUAIG_ID = 2;
export const INFORMATION_BLOCKS_ID = 3;
export const VIDEO_ASSESSMENT_ID = 4;
export const SIGNAL_HIRE_ID = 5;
export const VIDEO_INTRODUCTION_ID = 6;
export const DWI_ID = 8;
export const CANDIDATES_MAP_ID = 9;
